import FeatureButton from '@tcomponents/FeatureButton/FeatureButton'
import { ReactComponent as TrashIcon } from '../../../assets/deleteIcon.svg'
import { COLLECTION_ADMINISTRATION_CODES } from '@constants/modules/collectionAdministration/collectionAdministrationCodes'

export const dropdownCollectionAdministrationItems = ({
    onDelete,
    charge_instance_id
}) => {

    const defaultOptions = [
        {
            key: 3,
            label: <FeatureButton
                dropdownItem
                code={COLLECTION_ADMINISTRATION_CODES.COLLECTION_ADMINISTRATION_DELETE_COLLECTION}
                icon={<TrashIcon color="#4D4D4D" />}
                onClick={() => {
                    return onDelete({ charge_instance_id, isDeleted: true })
                }}
            >
                Eliminar
            </FeatureButton>,
            action: () => {

            }
        }
    ]


    return defaultOptions
}